'use client';
import { ProductComparisonItemProps } from '@/decodo/blocks/ProductComparisonTable/ProductComparisonTable';
import AccordionList from '@/decodo/components/molecules/accordion/AccordionList';

import { ComparisonText } from './comparisonUtils/comparisonElements/ComparisonText';
import { ProductCategoryTitles } from './comparisonUtils/comparisonElements/ProductCategory';
import { ProductFeatures } from './comparisonUtils/comparisonElements/ProductFeatureData';
import { MobileComparisonRow } from './comparisonUtils/comparisonSections/ComparisonRow';
import { SectionHeader } from './comparisonUtils/comparisonSections/MobileSectionHeader';
import { PriceAndButtonComparison } from './comparisonUtils/comparisonSections/PriceActionRow';
import { ProductComparisonTableProps } from './DesktopComparisonGrid';

export function MobileComparisonGrid({
  selectedData,
  productTypeCategoryTitle,
  productTypeCategoryTooltip,
  keyFeaturesTitle,
  keyFeaturesTooltip,
  descriptionTitle,
  descriptionTooltip,
  productFeaturesCategoryTitles,
  accordionContent,
  stickyOffsetTop,
}: ProductComparisonTableProps) {
  const [item1, item2] = selectedData;

  const product1 =
    item1?.productType || ({} as ProductComparisonItemProps['productType']);
  const product2 =
    item2?.productType || ({} as ProductComparisonItemProps['productType']);

  const headerTopMarginOffset = 60;
  return (
    <div className='flex flex-col gap-3'>
      {!!productTypeCategoryTitle && (
        <>
          <SectionHeader
            title={productTypeCategoryTitle}
            tooltip={productTypeCategoryTooltip}
          />
          <MobileComparisonRow
            left={<ComparisonText {...product1?.productType} />}
            right={<ComparisonText {...product2?.productType} />}
          />
        </>
      )}
      {!!keyFeaturesTitle && (
        <>
          <SectionHeader
            title={keyFeaturesTitle}
            tooltip={keyFeaturesTooltip}
          />
          <div className='bg-base-white rounded'>
            <MobileComparisonRow
              left={<ComparisonText {...product1?.features} />}
              right={<ComparisonText {...product2?.features} />}
            />
          </div>
        </>
      )}
      {!!descriptionTitle && (
        <>
          <SectionHeader
            title={descriptionTitle}
            tooltip={descriptionTooltip}
          />
          <div className='bg-base-white rounded'>
            <MobileComparisonRow
              left={<ComparisonText {...product1?.description} />}
              right={<ComparisonText {...product2?.description} />}
            />
          </div>
        </>
      )}
      <div
        style={{ top: (stickyOffsetTop ?? 0) + headerTopMarginOffset }}
        className='bg-gray-25 m:z-auto sticky z-10 grid grid-cols-2 gap-4 '
      >
        <div className='border-r border-gray-200 pr-4'>
          <PriceAndButtonComparison product={product1} />
        </div>
        <div>
          <PriceAndButtonComparison product={product2} />
        </div>
      </div>

      {productFeaturesCategoryTitles?.map((title, rowIdx) => (
        <div
          key={`mobile-feature-${rowIdx}`}
          className='text-body-m-medium mb-4'
        >
          <ProductCategoryTitles {...title} />
          <div className='bg-base-white text-body-m relative mt-3 grid grid-cols-2 gap-4'>
            <div className='border-r border-gray-200 p-2 pr-4'>
              {item1?.productTypeFeatures?.[rowIdx] && (
                <ProductFeatures {...item1.productTypeFeatures[rowIdx]} />
              )}
            </div>
            <div className='p-2'>
              {item2?.productTypeFeatures?.[rowIdx] ? (
                <ProductFeatures {...item2.productTypeFeatures[rowIdx]} />
              ) : (
                <div className='items-center '>–</div>
              )}
            </div>
          </div>
        </div>
      ))}

      {accordionContent && (
        <div className='mt-8'>
          <AccordionList accordionList={accordionContent} isMultiMode />
        </div>
      )}
    </div>
  );
}
